import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { catchError, from, map, Observable, of, switchMap, throwError } from "rxjs";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { AccountInfo, InteractionRequiredAuthError, RedirectRequest, SilentRequest } from '@azure/msal-browser';
import { LocalStorageKeys } from "../enums/LocalStorageKeys";
import { AuthService } from "src/app/auth/auth.service";
import { TokenService } from "../services/token.service";
import { Router } from "@angular/router";
import { PublicRequestService } from "src/app/services/public-request.service";
import { TranslateService } from "@ngx-translate/core";
import { TokenRefreshService } from "src/app/auth/token-refresh.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly scopes = this.authService.scopes;

  constructor(
    private readonly authService: AuthService,
    private readonly tokenRefreshService: TokenRefreshService,
    private readonly publicRequestService: PublicRequestService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // 🔓 Rutas públicas
    if (this.publicRequestService.isPublicRoute()) {
      return next.handle(req);
    }

    return this.tokenRefreshService.getValidAccessToken(this.scopes).pipe(
      switchMap(token => {
        const cloned = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
        return next.handle(cloned);
      }),
      catchError(err => {
        // El interceptor NO decide UX
        console.error('[AuthInterceptor]', err);
        return throwError(() => err);
      })
    );
  }


}